<odl-menu [attr.for]="popoverFor()" distance="4" placement="bottom-start">
  @if (featureFlags.isEnabled('tts')() && isTtsSupported()) {
    <odl-menu-item (odl-select)="startAutomatedReading()">
      <odl-icon name="play" slot="icon"></odl-icon>
      <span>{{ 'AUTOMATED_READING' | translate }}</span>
    </odl-menu-item>
  }

  @if (featureFlags.isEnabled('accessibility')()) {
    <odl-menu-item>
      <odl-icon name="accesibility" slot="icon"></odl-icon>
      <span>{{ 'ACCESSIBILITY_SETTINGS' | translate }}</span>

      <odl-menu-item slot="submenu">
        <odl-icon name="voice_control" slot="icon"></odl-icon>
        <span>{{ 'VOICE_CONTROL' | translate }}</span>
        <odl-menu-item slot="submenu">
          <odl-icon name="mic" slot="icon"></odl-icon>
          <span>{{ 'ENABLE_MICROPHONE' | translate }}</span>
          <odl-menu-item
            [checked]="!microphoneEnabled()"
            type="checkbox"
            slot="submenu"
            (odl-select)="setMicrophoneStatus(false)"
            >{{ 'MICROPHONE_DISABLED' | translate }}</odl-menu-item
          >
          <odl-menu-item
            [checked]="microphoneEnabled()"
            type="checkbox"
            slot="submenu"
            (odl-select)="setMicrophoneStatus(true)"
            >{{ 'MICROPHONE_ENABLED' | translate }}</odl-menu-item
          >
        </odl-menu-item>
        <odl-menu-item slot="submenu">
          <div class="microphone-permissions">
            <span>{{ 'MICROPHONE_PERMISSIONS' | translate }}</span>
            <odl-tag [variant]="microphonePermissionVariant()" size="small">
              {{ microphonePermissionLabel() }}
            </odl-tag>
          </div>
        </odl-menu-item>
        <odl-menu-item slot="submenu">
          <odl-icon name="language" slot="icon"></odl-icon>
          <span>{{ 'LANGUAGE' | translate }}</span>
          <odl-menu-item checked="" type="checkbox" slot="submenu">
            {{ 'SPANISH' | translate }}
          </odl-menu-item>
          <odl-menu-item type="checkbox" slot="submenu">{{ 'ENGLISH' | translate }}</odl-menu-item>
        </odl-menu-item>
      </odl-menu-item>
      <odl-menu-item slot="submenu">
        <odl-icon name="contrast" slot="icon"></odl-icon>
        <span>{{ 'HIGH_CONTRAST' | translate }}</span>

        <odl-menu-item
          (odl-select)="setHighContrastMode(HighContrastMode.NONE)"
          [checked]="highContrastMode() === HighContrastMode.NONE"
          type="checkbox"
          slot="submenu"
          >{{ 'DISABLED' | translate }}</odl-menu-item
        >
        <odl-menu-item
          (odl-select)="setHighContrastMode(HighContrastMode.LIGHT)"
          [checked]="highContrastMode() === HighContrastMode.LIGHT"
          type="checkbox"
          slot="submenu"
          >{{ 'LIGHT' | translate }}</odl-menu-item
        >
        <odl-menu-item
          (odl-select)="setHighContrastMode(HighContrastMode.DARK)"
          [checked]="highContrastMode() === HighContrastMode.DARK"
          type="checkbox"
          slot="submenu"
          >{{ 'DARK' | translate }}</odl-menu-item
        >
      </odl-menu-item>

      <odl-menu-item slot="submenu">
        <odl-icon name="accesibility_mode" slot="icon"></odl-icon>
        <span>{{ 'ACCESSIBILITY_MODE' | translate }}</span>

        <odl-menu-item
          (odl-select)="setAccessibilityMode(true)"
          [checked]="accessibilityMode()"
          type="checkbox"
          slot="submenu"
          >{{ 'ENABLED' | translate }}</odl-menu-item
        >
        <odl-menu-item
          (odl-select)="setAccessibilityMode(false)"
          [checked]="!accessibilityMode()"
          type="checkbox"
          slot="submenu"
          >{{ 'DISABLED' | translate }}</odl-menu-item
        >
      </odl-menu-item>
    </odl-menu-item>
  }

  @if (isOfflineModeEnabled()) {
    <odl-menu-item (odl-select)="openOfflineReadingModal()">
      <odl-icon name="cloud_download" slot="icon"></odl-icon>
      <span>{{ 'OFFLINE_READING' | translate }}</span>
    </odl-menu-item>
  }

  @if (featureFlags.isEnabled('languageSelector')()) {
    <odl-menu-item>
      <odl-icon name="language" slot="icon"></odl-icon>
      <span>{{ 'LANGUAGE' | translate }}</span>

      <odl-menu-item
        (odl-select)="setLanguage(LanguageOption.SPANISH)"
        [checked]="languageOption() === LanguageOption.SPANISH"
        type="checkbox"
        slot="submenu"
        >{{ 'SPANISH' | translate }}</odl-menu-item
      >
      <odl-menu-item
        (odl-select)="setLanguage(LanguageOption.ENGLISH)"
        [checked]="languageOption() === LanguageOption.ENGLISH"
        type="checkbox"
        slot="submenu"
        >{{ 'ENGLISH' | translate }}</odl-menu-item
      >
    </odl-menu-item>
  }

  <odl-menu-item (odl-select)="toggleFullscreen()">
    <odl-icon [name]="isFullscreen() ? 'fullscreen_exit' : 'fullscreen'" slot="icon"></odl-icon>
    <span>{{ (isFullscreen() ? 'EXIT_FULLSCREEN' : 'FULLSCREEN') | translate }}</span>
  </odl-menu-item>

  @if (featureFlags.isEnabled('help')()) {
    <odl-menu-item (odl-select)="openHelp()">
      <odl-icon name="help" slot="icon"></odl-icon>
      <span>{{ 'HELP' | translate }}</span>
    </odl-menu-item>
  }
</odl-menu>
